<template lang="pug">
  div.world
    img(src="../../assets/world.png")
    .cover(:class="{right: value.lng >= 0, top: value.lat >= 0, bottom: value.lat < 0, left: value.lng < 0}")
</template>

<script>
export default {
  props: ['value']
}
</script>

<style lang="scss" scoped>
  .world img {
    width: 50px;
    height: 33px;
    position: absolute;
    border-radius: 5px;
  }

  .world {
    position: relative;
    width: 50px;
    height: 33px;

    .cover {
      position: absolute;
      opacity: 0.4;
      background-color: green;
      width: 25px;
      height: 13px;
      border-radius: 5px 0 0 0;
    }
  }

  .top {
    top: 0;
  }
  .right {
    right: 0;
  }
  .bottom {
    bottom: 0;
  }
  .left {
    left: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/WorldCoordinates.vue